// extracted by mini-css-extract-plugin
export const mainNavbar = "main-nav-module--mainNavbar--19Fl5";
export const mainNavContainer = "main-nav-module--mainNavContainer--3QhhD";
export const mobileNavLink = "main-nav-module--mobileNavLink--2Wu8e";
export const contactButton = "main-nav-module--contactButton--29OdH";
export const mobileMenu = "main-nav-module--mobileMenu--3tTno";
export const mobileNavButton = "main-nav-module--mobileNavButton--VwSrl";
export const mobileNavButtonOpen = "main-nav-module--mobileNavButtonOpen--1H9CV";
export const mobileMenuSection = "main-nav-module--mobileMenuSection--cFZDO";
export const mobileMenuCopyright = "main-nav-module--mobileMenuCopyright--Vh6q3";